<template>
  <span
    v-tippy="{ placement: 'left' }"
    :title="tooltip"
  >
    <button
      class="button has-text-info"
      :disabled="loading || disabled"
      @click.prevent="downloadCSV"
    >
      <span class="icon">
        <i class="fal fa-file-csv" />
      </span>
    </button>
  </span>
</template>

<script>
import * as CSVService from '../services/csv.service'
export default {
  name: 'DownloadCSVButton',
  props: {
    columns: {
      type: Array,
      required: true
    },
    getEntries: {
      type: Function,
      required: true
    },
    postfix: {
      type: String,
      default: 'export'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: 'Download CSV'
    },
    filename: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async downloadCSV() {
      this.loading = true

      try {
        const entries = await this.getEntries()
        await CSVService.downloadCSV(this.columns, entries, this.postfix, this.filename || null)
      } catch {
        this.$notify('Something went wrong while downloading the CSV')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
